/* Svensk katalog for locale-projects-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'pj.tab.time': 'Tidrapportering',
  'pj.tab.overview': 'Översikt',
  'pj.tab.settings': 'Inställningar',
  'pj.day.mon': 'Mån',
  'pj.day.tue': 'Tis',
  'pj.day.wed': 'Ons',
  'pj.day.thu': 'Tor',
  'pj.day.fri': 'Fre',
  'pj.day.sat': 'Lör',
  'pj.day.sun': 'Sön',
  'pj.person.fallback': 'dig',
  'pj.time.title': 'Tidrapportering för {name}',
  'pj.week.label': 'Vecka {week}',
  'pj.week.word': 'Vecka',
  'pj.week.pick': 'Välj vecka',
  'pj.week.current': 'Denna vecka',
  'pj.week.back': 'Tre veckor bakåt',
  'pj.week.forward': 'Tre veckor framåt',
  'pj.week.prev': 'Föregående vecka',
  'pj.week.next': 'Nästa vecka',
  'pj.month.prev': 'Föregående månad',
  'pj.month.next': 'Nästa månad',
  'pj.month.entries': 'Registrerade timmar i {month}',
  'pj.month.dayHours': '{hours} registrerade',
  'pj.view.day': 'Dag',
  'pj.view.week': 'Vecka',
  'pj.day.empty': 'Inga timmar registrerade denna dag.',
  'pj.table.projectActivity': 'Projekt / aktivitet',
  'pj.table.sum': 'Summa',
  'pj.table.hours': 'Timmar',
  'pj.row.new': 'Ny rad',
  'pj.row.add': 'Lägg till',
  'pj.row.remove': 'Ta bort raden',
  'pj.row.pickBoth': 'Välj projekt och aktivitet',
  'pj.select.project': 'Välj projekt …',
  'pj.select.activity': 'Välj aktivitet …',
  'pj.select.projectSearch': 'Sök efter projekt …',
  'pj.select.activitySearch': 'Sök efter aktivitet …',
  'pj.select.projectEmpty': 'Inga projekt matchar sökningen.',
  'pj.select.activityEmpty': 'Inga aktiviteter matchar sökningen.',
  'pj.project.createAction': 'Skapa nytt projekt',
  'pj.activity.createAction': 'Skapa ny aktivitet',
  'pj.activity.none': 'Projektet har inga aktiviteter ännu. Skapa en här.',
  'pj.lock.state.done': 'Tidrapporteringen är registrerad som klar till och med {date}.',
  'pj.lock.state.open': 'Tidrapporteringen är inte registrerad som klar',
  'pj.lock.markWeek': 'Markera som klar till och med vecka {week}',
  'pj.lock.undo': 'Ångra',
  'pj.lock.done': 'Tidrapporteringen är markerad som klar till och med vecka {week}',
  'pj.lock.undone': 'Tidrapporteringen har öppnats igen',
  'pj.entry.newTitle': 'Ny tidregistrering',
  'pj.entry.editTitle': 'Ändra tidpost',
  'pj.entry.invoicedLocked': 'Timmarna är fakturerade och kan inte ändras. Ta bort eller kreditera fakturautkastet för att frigöra dem.',
  'pj.entry.periodLocked': 'Tidrapporteringen för denna period är markerad som klar.',
  'pj.entry.invoicedShort': 'Fakturerad',
  'pj.field.project': 'Projekt',
  'pj.field.activity': 'Aktivitet',
  'pj.field.hours': 'Antal timmar',
  'pj.field.date': 'Datum',
  'pj.field.description': 'Beskrivning',
  'pj.field.descriptionHint': 'Vad gick timmarna till? Texten följer med på fakturan.',
  'pj.field.name': 'Namn',
  'pj.field.number': 'Nummer',
  'pj.field.customer': 'Kund',
  'pj.field.contact': 'Kontaktperson',
  'pj.field.optional': 'Valfritt',
  'pj.field.defaultActivity': 'Standardaktivitet',
  'pj.field.product': 'Produkt',
  'pj.field.rate': 'Timpris',
  'pj.field.start': 'Start',
  'pj.field.end': 'Slut',
  'pj.field.color': 'Färg',
  'pj.field.status': 'Status',
  'pj.overview.title': 'Tidöversikt',
  'pj.overview.week': 'Veckoöversikt',
  'pj.overview.month': 'Månadsöversikt',
  'pj.overview.reports': 'Rapporter',
  'pj.overview.total': 'Summa registrerat',
  'pj.overview.billable': '{hours} fakturerbart',
  'pj.overview.weekEntries': 'Registrerade timmar vecka {week}',
  'pj.overview.empty': 'Inga timmar registrerade under perioden',
  'pj.overview.emptyTitle': 'Inga timmar',
  'pj.filter.all': 'Alla',
  'pj.filter.period': 'Tidsperiod',
  'pj.filter.billing': 'Fakturering',
  'pj.filter.billable': 'Fakturerbar',
  'pj.filter.nonBillable': 'Ej',
  'pj.filter.invoicedLabel': 'Fakturerad',
  'pj.filter.invoiced': 'Fakturerad',
  'pj.filter.open': 'Ofakturerad',
  'pj.report.title': 'Registrerade timmar {from} – {to}',
  'pj.report.emptyTitle': 'Inga registreringar',
  'pj.report.emptyText': 'Inga timmar för vald period och valt filter.',
  'pj.report.print': 'Skriv ut',
  'pj.report.pdf': 'Ladda ner som PDF',
  'pj.report.pdfTitle': 'Tidrapport',
  'pj.report.pdfError': 'Det gick inte att ladda ner rapporten.',
  'pj.report.pdfUnavailable': 'Rapport-PDF är inte kopplad till backend.',
  'pj.report.opening': 'Öppnar utskrift …',
  'pj.basis.title': 'Faktureringsunderlag',
  'pj.basis.projectName': 'Projektnamn',
  'pj.basis.searchPlaceholder': 'Projekt, kund …',
  'pj.basis.summary': '{count} ofakturerade registreringar från {from} till {to}',
  'pj.basis.selected': 'Valda',
  'pj.basis.costs': 'Utlägg för vidarefakturering',
  'pj.basis.costText': 'Utlägg',
  'pj.basis.costSource': 'Källa',
  'pj.basis.costAmount': 'Belopp',
  'pj.basis.costEmployee': 'Anställds utlägg · {name}',
  'pj.basis.costPurchase': 'Bokfört inköp',
  'pj.basis.timesheet': 'Skapa tidrapport som bilaga',
  'pj.basis.create': 'Skapa fakturautkast',
  'pj.basis.created': 'Fakturautkast skapat för {project}',
  'pj.basis.pickOne': 'Välj minst en registrering',
  'pj.basis.error': 'Det gick inte att skapa fakturautkastet.',
  'pj.basis.emptyTitle': 'Inga ofakturerade timmar',
  'pj.basis.emptyText': 'Allt är fakturerat, eller så har inga fakturerbara timmar registrerats på projekt med kund ännu.',
  'pj.cost.tab': 'Utlägg',
  'pj.cost.title': 'Utlägg på projekt',
  'pj.cost.party': 'Anställd / leverantör',
  'pj.cost.voucher': 'Verifikation',
  'pj.cost.openVoucher': 'Visa verifikation',
  'pj.cost.noVoucher': 'Verifikationen är inte tillgänglig',
  'pj.cost.noVoucherHelp': 'Kostnaden har ingen fil kopplad till sig.',
  'pj.cost.noVoucherShort': 'Utan verifikation',
  'pj.cost.pending': 'För godkännande',
  'pj.cost.invoiced': 'Fakturerad',
  'pj.cost.notBillable': 'Ej fakturerbar',
  'pj.cost.toInvoice': 'Att fakturera',
  'pj.cost.searchLabel': 'Sök',
  'pj.cost.searchPlaceholder': 'Beskrivning, anställd, leverantör …',
  'pj.cost.openSum': '{amount} att fakturera',
  'pj.cost.totalAll': 'Summa alla träffar',
  'pj.cost.emptyTitle': 'Inga utlägg',
  'pj.cost.emptyText': 'Inga kostnader är kopplade till ett projekt ännu. Verifikationer kopplas till projekt i inkorgen, på inköpet eller när den anställda skickar in utlägget.',
  'pj.billing.always': 'Alltid',
  'pj.billing.ask': 'Fråga',
  'pj.billing.never': 'Aldrig',
  'pj.activity.newTitle': 'Ny aktivitet',
  'pj.activity.editTitle': 'Redigera aktivitet',
  'pj.activity.namePlaceholder': 'T.ex. Konsulttjänster',
  'pj.activity.noProduct': 'Ingen',
  'pj.activity.productHint': 'Timmarna faktureras som «{product}» och bokförs på konto {account}.',
  'pj.activity.noProductHint': 'Utan produkt bokförs timmarna som tjänsteförsäljning på konto 3020 med standardmomssats.',
  'pj.activity.rateHint': 'Exkl. moms. Om fältet är tomt används priset på produkten.',
  'pj.activity.neverHint': 'Timmarna hålls utanför faktureringsunderlaget. Använd detta för semester och internt arbete.',
  'pj.project.newTitle': 'Skapa nytt projekt',
  'pj.project.newShort': 'Nytt projekt',
  'pj.project.editTitle': 'Redigera projekt',
  'pj.project.numberHint': 'Förslag: {number}',
  'pj.project.customerHint': 'Utan kund kan timmarna inte faktureras.',
  'pj.project.noCustomer': 'Ingen kund (internt projekt)',
  'pj.project.closed': 'Avslutat',
  'pj.settings.title': 'Inställningar för tidrapportering',
  'pj.settings.activities': 'Aktiviteter',
  'pj.settings.projects': 'Projekt',
  'pj.settings.noActivitiesTitle': 'Inga aktiviteter ännu',
  'pj.settings.noActivitiesText': 'Aktiviteten bestämmer timpris och vilken produkt timmarna faktureras som.',
  'pj.settings.noProjectsFirst': 'Skapa ett projekt först.',
  'pj.settings.noProjectsTitle': 'Inga projekt ännu',
  'pj.settings.noProjectsText': 'Skapa ett projekt för att börja rapportera tid.',
  'pj.toast.entrySaved': 'Timmarna har registrerats',
  'pj.toast.entryUpdated': 'Tidposten har uppdaterats',
  'pj.toast.entryDeleted': 'Tidposten har tagits bort',
  'pj.toast.activitySaved': 'Aktiviteten har sparats',
  'pj.toast.activityDeleted': 'Aktiviteten har tagits bort',
  'pj.toast.projectSaved': 'Projektet har sparats',
  'pj.toast.projectDeleted': 'Projektet har tagits bort',
  'pj.error.saveEntry': 'Det gick inte att spara tidposten.',
  'pj.error.deleteEntry': 'Det gick inte att ta bort tidposten.',
  'pj.error.saveRows': 'Det gick inte att uppdatera raderna.',
  'pj.error.lock': 'Det gick inte att uppdatera låset.',
  'pj.error.saveActivity': 'Det gick inte att spara aktiviteten.',
  'pj.error.deleteActivity': 'Det gick inte att ta bort aktiviteten.',
  'pj.error.saveProject': 'Det gick inte att spara projektet.',
  'pj.error.deleteProject': 'Det gick inte att ta bort projektet.',
  'pj.validation.projectName': 'Projektet måste ha ett namn.',
  'pj.validation.endBeforeStart': 'Slutdatum kan inte vara före startdatum.',
  'pj.validation.activityName': 'Aktiviteten måste ha ett namn.',
  'pj.validation.activityProject': 'Aktiviteten måste höra till ett projekt.',
  'pj.validation.entryDate': 'Tidposten måste ha ett datum.',
  'pj.validation.entryHours': 'Antal timmar måste vara större än 0.',
  'pj.validation.entryHoursMax': 'En registrering kan inte vara mer än 24 timmar.',
  'pj.validation.entryNotFound': 'Tidposten hittades inte.',
  'pj.validation.entryInvoiced': 'Tidposten är redan fakturerad och kan inte ändras.',
  'pj.validation.periodLocked': 'Tidrapporteringen för denna period är markerad som klar.',
  'svc.projectNotFound': 'Projektet hittades inte.',
  'svc.projectNumberTaken': 'Projektnumret används redan.',
  'svc.projectHasHours': 'Projektet har registrerade timmar. Markera det som avslutat i stället för att ta bort det.',
  'svc.projectClosed': 'Projektet är avslutat och kan inte få nya timmar.',
  'svc.projectNeedsCustomer': 'Projektet måste ha en kund innan timmarna kan faktureras.',
  'svc.activityNotFound': 'Aktiviteten hittades inte.',
  'svc.activityHasHours': 'Aktiviteten har registrerade timmar och kan inte tas bort.',
  'svc.timeEntryNotFound': 'Tidposten hittades inte.',
  'svc.timeTrackingLocked': 'Tidrapporteringen för denna period är markerad som klar.',
  'svc.pickTimeEntries': 'Välj minst en ofakturerad tidregistrering.',
  'svc.timesheetInvoiceDescription': 'Timmar på {project} under perioden {from} – {to}.',
});
